<template>
	<section class="app-container form-high-contrast wide-section">
		<div class="container bulkupload-container">
			<div class="bulk-upload-header">
				<h1>Bulk Observation Upload</h1>
				<BulkUploadNavigation :user="current_user"></BulkUploadNavigation>
			</div>
			<div v-if="current_user">
				<div v-if="confirmed" class="alert alert-info">
		          <strong>Your import has been submitted for review.</strong>
		        </div>
				<div v-else class="row">
					<div class="col-md-6">
						<div v-bind:class="{'drop-zone' : $refs.upload && $refs.upload.dropActive}">
							<div v-if="!results">
								<strong>Upload your bulk zip containing your data (xlsx) and any asoociated photos:</strong>
								<hr />
								<label><strong>Upload Name</strong></label>
								<input v-model="uploadName" type="text" placeholder="Upload name for reference" />
								<br />
								<br />
								<label><strong>File Upload</strong></label><br />
								<file-upload
								  class="btn btn-primary"
								  :post-action="postAction"
								  :extensions="extensions"
								  :accept="accept"
								  :multiple="false"
								  :directory="false"
								  :size="0"
								  :thread="3"
								  :headers="get_headers()"
								  :data="file_data"
								  :name="'file'"
								  :input-id="'batchUpload'"
								  :drop="true"
								  :drop-directory="false"
								  :add-index="false"
								  v-model="files"
								  @input-file="inputFile"
								  ref="upload">
								  Select File
								</file-upload>
								<br />
							</div>
							<div v-for="(file, index) in files" :key="file.id" :class="'mgp-file-' + file.id">
								<strong>{{file.file.name}}</strong><br /><br />
								<div v-if="file.error && file.error == 'size'" class='alert alert-error'>
									This image is too large (> 10MB). <strong>It will not be included in your submission.</strong>
								</div>
								<label v-else-if="file.error" class="label label-warning label--inline">Errors found. Please review, fix, and reupload.</label>
								<div class="file-uplaoded" v-if="file.success">
									<i class="fa fa-check fa-3x" style="color:green;"></i>
									<strong style="color:green;font-size:2em;">File Uploaded</strong>
								</div>
								<div class="progress" v-else-if="file.active">
									<div :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}" role="progressbar" :style="{width: file.progress + '%'}">
										<span v-if="file.progress == 100">
											processing...
										</span>
										<span v-else>
											{{file.progress}}%
										</span>
									</div>
								</div>
							</div>
							<br />
							<button class="btn btn--primary btn-block btn-lg" v-if="!results" @click="upload()">Upload Observations</button>
						</div>
					</div>
					<div class="col-md-6" v-if="errors&& errors.length > 0">
						<h2>Import Errors</h2>
						<Paging></Paging>
						<PagingSummary v-model="meta"></PagingSummary>
						<table class="border--round table--alternate-row">
							<thead>
								<tr>
									<th>Line</th>
									<th>Error</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(line, index) in displayed_errors">
									<td>{{line.line}}</td>
									<td>
										<ul class="bullets">
											<li v-for="(field_errors, field) in line.line_errors">
												<span v-if="field">{{field}}: </span>
												<span v-for="(field_error, index) in field_errors"><span v-if="index != 0">, </span>{{field_error}}</span><br />
											</li>
										</ul>
									</td>
								</tr>
							</tbody>
						</table>
						<Paging></Paging>
					</div>
					<div class="col-md-12" v-if="results">
						<button class="btn btn--primary btn-lg pull-right" @click="confirm()">Confirm Upload</button>
						<h2>Import Sample</h2>
						<div v-if="results.notice" class="alert alert-warning">
							<strong>{{results.notice}}</strong>
						</div>
						<div class="table-responsive">
							<table class="border--round table--alternate-row">
								<thead>
									<tr>
										<th>specimen</th>
										<th>inaturalist_id</th>
										<th>scientific_name</th>
										<th>datetime</th>
										<th>project</th>
										<th>life_stage</th>
										<th>observer</th>
										<th>location_description</th>
										<th>count</th>
										<th>location_name</th>
										<th>latitude</th>
										<th>institution</th>
										<th>photo_filenames</th>
										<th>specimen_notes</th>
										<th>longitude</th>
										<th>observer_confidence</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="result in results.data">
										<td>{{result["specimen"]}}</td>
										<td>{{result["inaturalist_id"]}}</td>
										<td>{{result["scientific_name"]}}</td>
										<td>{{result["datetime"]}}</td>
										<td>{{result["project"]}}</td>
										<td>{{result["life_stage"]}}</td>
										<td>{{result["observer"]}}</td>
										<td>{{result["location_description"]}}</td>
										<td>{{result["count"]}}</td>
										<td>{{result["location_name"]}}</td>
										<td>{{result["latitude"]}}</td>
										<td>{{result["institution"]}}</td>
										<td>{{result["photo_filenames"]}}</td>
										<td>{{result["specimen_notes"]}}</td>
										<td>{{result["longitude"]}}</td>
										<td>{{result["observer_confidence"]}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						
					</div>
				</div>
			</div>
			<div v-if="!current_user && !loading_user">
				<div class="alert">
					<div class="alert__body">
						<span>Please login to add photos to sightings.</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import global_data from '../../main';
	import FileUpload from 'vue-upload-component'
	export default {
		name: 'BulkUploadComponent',
		metaInfo: {
			title: 'Bulk Upload Observations',
		},
		data: function(){
			return {
				loading_user: true,
				current_user: null,
				postAction: this.APIBaseURL() + 'uploads/',
				extensions: 'zip',
				accept: 'application/zip',
				files: [],
				uploadName: "",
				file_data: {},
				results:null,
				confirmed: false,
				errors:null,
				page: 1,
				meta: {
					page: 1,
					per_page: 10,
					total_pages: 0,
					total_results: 0,
				},
			};
		},
		mounted: function(){
			var self = this;
			global_data.$on("user_changed", function(user){
				self.get_user();
			});
			self.get_user();
		},
		watch:{
			uploadName: function () {
				this.bindFileChanges();
				
			},
			page: function(){
				this.meta.page = this.page;
			},
		},
		methods:{
			bindFileChanges:function(){
				var d = {
					name: this.uploadName
				};
				this.file_data = d;
				if (this.$refs.upload.files.length>0) {
					for (var i = this.$refs.upload.files.length - 1; i >= 0; i--) {
						this.$refs.upload.files[i].data = d;
					}
				}
			},
			confirm:function(){
				var self = this;
				this.API({
	                endpoint: 'uploads/' + self.results.upload.id,
	                isPatch:true,
	                postData: {
	                    status:'confirmed'
	                },
	                funcThen: function(response){
	                    self.confirmed = true;
	                }
	            });
			},
			get_step: function(){
				return 1;
			},
			get_user: function(){
				var self = this;
				self.GetAPIUser(function(user){
					self.current_user = user;
					self.loading_user = false;
				}, true);
			},
			get_headers:function(){
				if (this.$cookie.get('OCAuth') != null) {
					return {
						Authorization: 'Token ' + this.$cookie.get('OCAuth')
					}
	            }
	            return {};
			},
			inputFilter(newFile, oldFile, prevent) {
			},
			fix_errors(errors){
				var fixed_errors = [];
				for (var property in errors) {
				  fixed_errors.push({
				  	line:property,
				  	line_errors: errors[property]
				  });
				}
				return fixed_errors;
			},
			get_response_errors(response){
				var fixed_errors = [];

				for (var prop in response) {
				    if (Object.prototype.hasOwnProperty.call(response, prop)) {
				        fixed_errors.push({
							line:prop,
							line_errors: [response[prop]]
						});
				    }
				}
				return fixed_errors;
			},
			// add, update, remove File Event
			inputFile(newFile, oldFile) {
				if (newFile && !oldFile) {
					// Add file
				}

				if (newFile && oldFile) {
					// Update file

					// Start upload
					if (newFile.active !== oldFile.active) {
						console.log('Start upload', newFile.active, newFile)

						// min size
						if (newFile.size >= 0 && newFile.size < 1 * 1024) {
							newFile = this.$refs.upload.update(newFile, {error: 'size'})
						}
					}

					// Upload progress
					if (newFile.progress !== oldFile.progress) {
						console.log('progress', newFile.progress, newFile)
					}

					// Upload error
					if (newFile.error !== oldFile.error) {
						console.log('error', newFile.error, newFile)
						if (newFile.response.hasOwnProperty('errors')) {
							this.errors = this.fix_errors(newFile.response.errors);
						}
						else{
							this.errors = this.get_response_errors(newFile.response);
						}
						this.page = 1;
						this.meta = {
							page: 1,
							per_page: 10,
							total_pages: Math.ceil(this.errors.length / 10),
							total_results: this.errors.length,
						};
						console.log(this.errors);
					}

					// Uploaded successfully
					if (newFile.success !== oldFile.success) {
						console.log('success', newFile.success, newFile)
						this.results = newFile.response;
					}
				}

				if (!newFile && oldFile) {
					// Remove file

					// Automatically delete files on the server
					if (oldFile.success && oldFile.response.id) {
						// $.ajax({
						//   type: 'DELETE',
						//   url: '/file/delete?id=' + oldFile.response.id,
						// });
					}
				}

				// Automatic upload
				// if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
				// 	if (!this.$refs.upload.active) {
				// 		this.$refs.upload.active = true
				// 	}
				// }
			},
			upload: function(){
				this.clear_errors();
				console.log(this.$refs.upload.data);
				if (!this.$refs.upload.active) {
					this.$refs.upload.active = true
				}
			},
			clear_errors: function(){
				this.errors = null;
				this.meta.page = 1;
				this.page = 1;
			}
		},
		computed:{
			loading:{
				get: function(){
					return this.loading_user;
				}
			},
			errors_low:{
				get: function(){
					return (this.meta.page - 1) * this.meta.per_page + 1;
				}
			},
			errors_high:{
				get: function(){
					return (this.meta.page) * this.meta.per_page;
				}
			},
			displayed_errors:{
				get: function(){
					console.log(this.errors_low - 1,this.errors_high)
					return this.errors.slice(this.errors_low - 1, this.errors_high)
				}
			},
			max_page: function(){
				return this.meta.total_pages;
			},

		},
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/BulkUpload.vue